import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { Text, Divider, EntityLink, Flex } from '@sequencehq/core-components'
import {
  Primary14SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import { FC } from 'react'
import { toMoney } from '@sequencehq/utils'

interface InvoicesPopoverProps {
  invoiceIds: string[]
  total: string
}

export const InvoicesPopover: FC<InvoicesPopoverProps> = ({
  invoiceIds,
  total
}) => (
  <Flex flexDirection="column">
    <InvoicesDetailSection invoiceIds={invoiceIds}></InvoicesDetailSection>
    <Divider color="gray.30"></Divider>
    <InvoicesTotalSection total={total}></InvoicesTotalSection>
  </Flex>
)

type InvoicesDetailSectionProps = {
  invoiceIds: string[]
}

const InvoicesDetailSection: FC<InvoicesDetailSectionProps> = ({
  invoiceIds
}) => {
  return (
    <Flex flexDirection="column" padding="16px 16px 8px 16px" gap="8px">
      {invoiceIds.map(invoiceId => (
        <InvoiceSummary invoiceId={invoiceId} key={invoiceId} />
      ))}
    </Flex>
  )
}

interface InvoiceSummaryProps {
  invoiceId: string
}

const InvoiceSummary: FC<InvoiceSummaryProps> = ({ invoiceId }) => {
  const invoiceQuery = useQuery(dashboardv99990101Client.getInvoice, {
    id: invoiceId
  })

  const invoice = invoiceQuery.data

  if (!invoice) {
    return <></>
  }

  return (
    <Flex alignItems="center">
      <EntityLink to={`/invoices/${invoiceId}`}>
        {invoice.invoiceNumber || 'TBC'}
      </EntityLink>
      <Flex grow="1"></Flex>
      <Text {...Primary13Regular} color="gray.80">
        {/* Gross, like every total in this grid: they come from a server-side
            aggregate that has no credit-adjusted equivalent yet, so an adjusted
            row here would disagree with the total above it. */}
        {toMoney({ currency: invoice.currency, value: invoice.grossTotal })}
      </Text>
    </Flex>
  )
}

interface InvoicesTotalSectionProps {
  total: string
}

const InvoicesTotalSection: FC<InvoicesTotalSectionProps> = ({ total }) => {
  return (
    <Flex flexDirection="column" padding="16px">
      <Flex alignItems="center">
        <Text {...Primary14SemiBold} color="gray.80">
          Total
        </Text>
        <Flex grow="1"></Flex>
        <Text {...Primary14SemiBold} color="gray.80">
          {total}
        </Text>
      </Flex>
    </Flex>
  )
}
